import { CdkPortal } from '@angular/cdk/portal';
import { Directive, Input } from '@angular/core';

/**
 * Allows associating a value to a CdkPortal and being able to distinguish between them using that.
 *
 * Application usage:
 * ```html
 * <div *cdkPortal="0">Portal 0 content</div>
 * <div *cdkPortal="1">Portal 1 content</div>
 * ```
 *
 * Component implementation usage:
 * ```ts
 * import type { QueryList } from '@angular/core';
 * ...
 * export class SomeComponent {
 *   ...
 *
 *   @ContentChildren(CdkPortalValue)
 *   values: QueryList<CdkPortalValue>;
 *
 *   portal0: CdkPortal;
 *   portal1: CdkPortal;
 *
 *   ngAfterContentInit() {
 *     console.log(this.values);
 *     this.portal0 = this.values.filter(e => e.value === 0)[0]?.portal;
 *     this.portal1 = this.values.filter(e => e.value === 1)[0]?.portal;
 *   }
 *
 *   ...
 * }
 * ```
 */
@Directive({
  selector: 'ng-template[cdkPortal]',
  exportAs: 'cdkPortalValue',
})
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class CdkPortalValue<T = any> {
  @Input('cdkPortal') value?: T;

  constructor(public portal: CdkPortal) {}
}
